import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestUsuarios({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'usuariosoperadores', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteUsuario({ payload }) {
  try {
    const { idusuario, params } = payload;

    yield call(api.delete, `usuariosoperadores/${idusuario}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { usuario, params } = payload;

    yield call(api.post, 'usuariosoperadores', usuario);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/usuarios');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idusuario } = payload;

    const { data } = yield call(api.get, `usuariosoperadores/${idusuario}`);

    data.param5usuariooperador = JSON.stringify(data.param5usuariooperador);
    data.param7usuariooperador = JSON.stringify(data.param7usuariooperador);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { usuario, params } = payload;

    yield call(api.put, 'usuariosoperadores', usuario);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/usuarios');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'usuariosoperadores', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@usuario/USUARIOS_IN_REQUEST', requestUsuarios),
  takeLatest('@usuario/DELETE_USUARIO', deleteUsuario),
  takeLatest('@usuario/SUCCESS_REMOVE', requestUsuarios),
  takeLatest('@usuario/STORE_USUARIO', store),
  takeLatest('@usuario/FIND_USUARIO', find),
  takeLatest('@usuario/UPDATE_USUARIO', update),
  takeLatest('@usuario/RECORD_FILTERING', applyedFilters),
]);
